import { c as _c } from "react/compiler-runtime";
import { Text } from "@/components/ui/Text";
import type * as React from "react";

// A vertical activity trail (audit events, status history): each item is a
// hollow dot on a hairline rail with a 13/500 title, 12px meta line and
// optional detail copy.
/** Use when showing a sequence of events, such as audit history. */
export function Timeline(t0) {
  const $ = _c(2);
  const {
    children
  } = t0;
  let t1;
  if ($[0] !== children) {
    t1 = <ol className="flex flex-col">{children}</ol>;
    $[0] = children;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}
export function TimelineItem(t0) {
  const $ = _c(12);
  const {
    title,
    meta,
    children
  } = t0;
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <span aria-hidden="true" className="absolute left-1.25 top-3.5 h-full w-px bg-border-subtle group-last/timeline:hidden" />;
    t2 = <span aria-hidden="true" className="relative mt-1 size-2.5 shrink-0 rounded-full border-2 border-border-strong bg-bg-surface" />;
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  let t3;
  if ($[2] !== title) {
    t3 = <Text weight="medium">{title}</Text>;
    $[2] = title;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== meta) {
    t4 = meta && <Text size="sm" tone="tertiary">{meta}</Text>;
    $[4] = meta;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== children) {
    t5 = children && <Text as="div" tone="secondary">{children}</Text>;
    $[6] = children;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== t3 || $[9] !== t4 || $[10] !== t5) {
    t6 = <li className="group/timeline relative flex gap-3 pb-4 last:pb-0">{t1}{t2}<div className="flex min-w-0 flex-1 flex-col gap-0.5">{t3}{t4}{t5}</div></li>;
    $[8] = t3;
    $[9] = t4;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  return t6;
}